<template>
  <div class="WLocation el-input el-input--small">
    <el-input v-model="formData[item.id]" readonly :disabled="disabled">
      <el-button
        size="medium"
        type="text"
        slot="suffix"
        icon="el-icon-map-location"
        @click="handldEdit"
        :disabled="disabled"
      ></el-button>
    </el-input>
    <Location
      v-if="visible"
      ref="location"
      @handleClosed="handleClosed"
      @handleSaveLocation="handleSaveLocation"
    />
  </div>
</template>

<script>
import Location from '@/views/Report/ReportEditor/Location'
export default {
  name: 'WLocation',
  components: {
    Location
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入控件
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    // 表单对象
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  computed: {
    locationValue() {
      if (this.item.specDisplay && this.item.specDisplay.mapDisplay && this.item.specDisplay.mapDisplay.length) {
        const value = this.item.specDisplay.mapDisplay.map(m => {
          return {
            name: m.specName,
            specId: m.specId,
            id: m.fieldId,
            value: this.formData[m.fieldId]
          }
        })
        return value
      } else {
        return []
      }
    },
  },
  data() {
    return {
      singleTemp: {
        startContent: '',
        startPoint: {
          lng: 116.404, // 经度
          lat: 39.915 // 纬度
        },
      },
      visible: false,
      mapObj: {
        specId: 101,
        autoLoc: false,
        manualLoc: true,
        manualName: false,
        limits: false,
        nearBy: {
          center: {
            lng: 116.404, // 经度
            lat: 39.915 // 纬度
          },
          radius: 200
        },
        startPoint: {
          lng: 116.404, // 经度
          lat: 39.915 // 纬度
        },
        endPoint: {},
        startContent: '',
        endContent: ''
      }
    }
  },
  methods: {
    handleClosed() {
      this.visible = false
    },
    // 保存
    handleSaveLocation(val) {
      console.log(val)
      this.locationValue.forEach(l => {
        switch (l.specId) {
          case 0:
            this.formData[l.id] = val.startContent
            break;
          case 1:
            this.formData[l.id] = val.startPoint.lng
            break;
          case 2:
            this.formData[l.id] = val.startPoint.lat
            break;
        }
      });
      this.$emit('handleUpdate', this.locationValue)
    },
    handldEdit() {
      this.visible = true
      this.$nextTick(() => {
        console.log(this.item)
        this.locationValue.forEach(l => {
          switch (l.specId) {
            case 0:
              this.singleTemp.startContent = l.value
              break;
            case 1:
              this.singleTemp.startPoint.lng = l.value || this.singleTemp.startPoint.lng
              break;
            case 2:
              this.singleTemp.startPoint.lat = l.value || this.singleTemp.startPoint.lat
              break;
          }
        });
        this.mapObj = Object.assign(this.mapObj, this.item.specDisplay)
        this.mapObj = Object.assign(this.mapObj, this.singleTemp)
        this.$refs.location.handleOpenLocation(this.mapObj)
      })
    },
  }
}
</script>

<style lang="scss">
.WLocation {
  .el-button {
    padding: 0 !important;
  }
  /* height: 28px; */
  /* margin-top: 6px; */
}
</style>